import * as React from "react";
import type { SVGProps } from "react";
const SvgMobilePhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.62 17.92c.12.06.25.08.38.08s.26-.02.38-.08c.13-.05.23-.12.33-.21.18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.1-.09-.2-.16-.33-.21a1 1 0 0 0-.76 0c-.13.05-.23.12-.33.21-.18.19-.29.45-.29.71s.11.52.29.71c.1.09.2.16.33.21"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 19c0 1.65-1.35 3-3 3H8c-1.65 0-3-1.35-3-3V5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3zM8 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-1c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMobilePhone;
